import { render, staticRenderFns } from "./pendingShipmentPackages.vue?vue&type=template&id=7b3b1faa&scoped=true&"
import script from "./pendingShipmentPackages.vue?vue&type=script&lang=js&"
export * from "./pendingShipmentPackages.vue?vue&type=script&lang=js&"
import style0 from "./pendingShipmentPackages.vue?vue&type=style&index=0&id=7b3b1faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3b1faa",
  null
  
)

export default component.exports